import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";

const RATIO = 410 / 512; // the mark's artwork aspect

/**
 * The Mahano "M" with its jade tick animated — the tick wipes in left to right,
 * like something being ticked off, then settles.
 */
export default function MahanoTickMark({ size = 96, tone, animate = true, className = "" }) {
  const { theme } = useTheme();
  const surface = (tone || theme) === "dark" ? "on-dark" : "on-light";
  return (
    <span
      className={cn("relative inline-block", animate && "mahano-tick-pop", className)}
      style={{ width: size, height: size * RATIO }}
      aria-hidden="true"
      data-testid="mahano-tick-mark"
    >
      <img src={`/brand/mark-body-${surface}.png`} alt=""
           className="absolute inset-0 h-full w-full object-contain" draggable="false" />
      <img src="/brand/mark-tick.png" alt="" data-testid="mahano-tick-layer"
           className={cn("absolute inset-0 h-full w-full object-contain", animate && "mahano-tick")}
           draggable="false" />
    </span>
  );
}
